import { http } from "../utils/http";

export const listEmployeeContracts = (query = "") =>
    http.get(`/employee-contracts${query.trim() ? `?query=${encodeURIComponent(query.trim())}` : ""}`);

export const createManualContractGeneration = (data, documents) => {
    const body = new FormData();
    Object.entries(data).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") body.append(key, value);
    });
    documents.forEach(({ kind, file }) => {
        body.append("kinds", kind);
        body.append("files", file, file.name);
    });
    return http.post("/employee-contracts/manual-generation", body);
};

export const uploadEmployeeContract = (employeeId, documentType, file) => {
    const body = new FormData();
    body.append("document_type", documentType);
    body.append("file", file, file.name);
    return http.post(`/employees/${employeeId}/contracts`, body);
};

export const deleteEmployeeContract = (documentId) =>
    http.del(`/employee-contracts/${documentId}`);

export const returnEmployeeToCandidateDocuments = (employeeId) =>
    http.post(`/employees/${employeeId}/return-to-candidate-documents`, {});

export const retryEmployeeContractGeneration = (employeeId, options = {}) =>
    http.post(`/employees/${employeeId}/contracts/retry-generation`, options);

export const getEmployeeContractsPrintPackage = (employeeId) =>
    http.getBlob(`/employees/${employeeId}/contracts/print-package`);

export const getEmployeeContractFile = (documentId) =>
    http.getBlob(`/employee-contracts/${documentId}/file`);
